var map = {
	"./account-balance.svg": [
		"ff92"
	],
	"./add-photo.svg": [
		"af6c"
	],
	"./add-user.svg": [
		"83bc",
		"chunk-2d0de172"
	],
	"./alert-folder.svg": [
		"5f62",
		"chunk-2d0d3e43"
	],
	"./animal.svg": [
		"a29b",
		"chunk-2d207bf0"
	],
	"./approval.svg": [
		"642a",
		"chunk-2d0cf6a3"
	],
	"./arrow-down-full.svg": [
		"4b07",
		"chunk-2d0cba2b"
	],
	"./arrow-down-sort.svg": [
		"8985",
		"chunk-2d0df2b4"
	],
	"./arrow-down.svg": [
		"b95b"
	],
	"./arrow-left-circle.svg": [
		"b779",
		"chunk-2d2102ad"
	],
	"./arrow-left-full.svg": [
		"f82f",
		"chunk-2d22d77c"
	],
	"./arrow-left.svg": [
		"6873",
		"chunk-2d0d0614"
	],
	"./arrow-right-circle.svg": [
		"fe056",
		"chunk-774c7f7c"
	],
	"./arrow-right-full.svg": [
		"6a86"
	],
	"./arrow-right.svg": [
		"6fb3"
	],
	"./arrow-up-full.svg": [
		"9111",
		"chunk-2d0e482e"
	],
	"./arrow-up-sort.svg": [
		"1088",
		"chunk-2d0aa255"
	],
	"./arrow-up.svg": [
		"ad57",
		"chunk-2d2136fb"
	],
	"./attach.svg": [
		"3baf",
		"chunk-2d0c4bea"
	],
	"./backspace.svg": [
		"e9d6",
		"chunk-2d226cbc"
	],
	"./balance.svg": [
		"cea5",
		"chunk-2d2228cc"
	],
	"./bills.svg": [
		"4384",
		"chunk-2d0c0ab1"
	],
	"./block.svg": [
		"f9df",
		"chunk-2d22e14b"
	],
	"./briefcase.svg": [
		"64e4",
		"chunk-2d0cfca3"
	],
	"./brokenImage.svg": [
		"fa2c",
		"chunk-2d237162"
	],
	"./building.svg": [
		"cd97",
		"chunk-2d222035"
	],
	"./calendar.svg": [
		"00f3"
	],
	"./camera.svg": [
		"e596",
		"chunk-2d225883"
	],
	"./car.svg": [
		"5735",
		"chunk-2d0c8d7a"
	],
	"./card-add.svg": [
		"3d57",
		"chunk-2d0c4de9"
	],
	"./card-recharge.svg": [
		"dd70",
		"chunk-2d22944f"
	],
	"./carousel.svg": [
		"5650",
		"chunk-2d0c89f2"
	],
	"./cart.svg": [
		"8a3a",
		"chunk-2d0e886d"
	],
	"./chart.svg": [
		"5b3a",
		"chunk-2d0d2f11"
	],
	"./chat.svg": [
		"f076",
		"chunk-2d22b9df"
	],
	"./check-circle.svg": [
		"0381"
	],
	"./check-folder.svg": [
		"f932",
		"chunk-2d22db28"
	],
	"./check-line.svg": [
		"6184"
	],
	"./check-list.svg": [
		"5f94",
		"chunk-2d0d3ea2"
	],
	"./checkbox-error.svg": [
		"ed3a",
		"chunk-2d230863"
	],
	"./checkbox-selected.svg": [
		"25b4"
	],
	"./checkbox.svg": [
		"b05c",
		"chunk-2d20e852"
	],
	"./clock.svg": [
		"2e90",
		"chunk-2d0bddc0"
	],
	"./close.svg": [
		"9d4a",
		"chunk-2d0f082e"
	],
	"./clothing.svg": [
		"4cf2",
		"chunk-2d0cc471"
	],
	"./coin-drop.svg": [
		"d4dc",
		"chunk-2d21e5c5"
	],
	"./coin.svg": [
		"2949",
		"chunk-2d0b3802"
	],
	"./comunication.svg": [
		"369e",
		"chunk-2d0ba1e5"
	],
	"./contact.svg": [
		"66aa",
		"chunk-2d0d03d6"
	],
	"./copy.svg": [
		"5c70"
	],
	"./credit-card.svg": [
		"b1d8",
		"chunk-2d20f199"
	],
	"./currency-exchange.svg": [
		"1d82",
		"chunk-2d0b6583"
	],
	"./cycle.svg": [
		"59e4"
	],
	"./dashboard.svg": [
		"bab7",
		"chunk-2d21a58a"
	],
	"./delete.svg": [
		"ce94",
		"chunk-2d2223f3"
	],
	"./document-confirm.svg": [
		"fc6d",
		"chunk-2d237961"
	],
	"./document-edit.svg": [
		"c72f",
		"chunk-2d21769e"
	],
	"./document-people.svg": [
		"035c",
		"chunk-2d0a3907"
	],
	"./document.svg": [
		"79de",
		"chunk-2d0d83d9"
	],
	"./download.svg": [
		"1b60",
		"chunk-2d0b5dc1"
	],
	"./drag.svg": [
		"c273",
		"chunk-2d216441"
	],
	"./education.svg": [
		"f989",
		"chunk-2d22dbca"
	],
	"./error-fill.svg": [
		"4523"
	],
	"./error.svg": [
		"4a3e"
	],
	"./eye-close.svg": [
		"b161",
		"chunk-2d20ec00"
	],
	"./eye-lock.svg": [
		"f776",
		"chunk-2d22d426"
	],
	"./eye-open.svg": [
		"16b0",
		"chunk-2d0abde9"
	],
	"./face-id.svg": [
		"9dee",
		"chunk-2d0f0e21"
	],
	"./fact-check.svg": [
		"bd34",
		"chunk-2d21ab19"
	],
	"./fast-transfer.svg": [
		"2ae7",
		"chunk-2d0bd417"
	],
	"./filter.svg": [
		"312d",
		"chunk-2d0b8e46"
	],
	"./finance.svg": [
		"766f",
		"chunk-2d0d7305"
	],
	"./fingerprint.svg": [
		"04f6",
		"chunk-2d0a428a"
	],
	"./flags/AED-flag.svg": [
		"2c9b",
		"chunk-2d0bd670"
	],
	"./flags/AKZ-flag.svg": [
		"5f24",
		"chunk-2d0d3dc9"
	],
	"./flags/CAD-flag.svg": [
		"135a",
		"chunk-2d0aad64"
	],
	"./flags/CHF-flag.svg": [
		"b72a",
		"chunk-2d21023a"
	],
	"./flags/CNY-flag.svg": [
		"0ea2",
		"chunk-2d0af9dc"
	],
	"./flags/DKK-flag.svg": [
		"06a7",
		"chunk-2d0a4972"
	],
	"./flags/EUR-flag.svg": [
		"66d2",
		"chunk-2d0d0404"
	],
	"./flags/GBP-flag.svg": [
		"9d54",
		"chunk-2d0f0820"
	],
	"./flags/JPY-flag.svg": [
		"a4c4",
		"chunk-2d20885a"
	],
	"./flags/MZN-flag.svg": [
		"fae3",
		"chunk-2d23775f"
	],
	"./flags/NAD-flag.svg": [
		"72bb",
		"chunk-2d0d6951"
	],
	"./flags/NOK-flag.svg": [
		"3ebf",
		"chunk-2d0c574c"
	],
	"./flags/SEK-flag.svg": [
		"77d7",
		"chunk-2d0d7c29"
	],
	"./flags/USD-flag.svg": [
		"d206",
		"chunk-2d21d7ca"
	],
	"./flags/XAF-flag.svg": [
		"0900",
		"chunk-2d0a4ebf"
	],
	"./flags/ZAR-flag.svg": [
		"9417",
		"chunk-2d0e5377"
	],
	"./flags/flag.svg": [
		"1373",
		"chunk-2d0aad74"
	],
	"./food.svg": [
		"eb8e",
		"chunk-2d230180"
	],
	"./group.svg": [
		"6c94",
		"chunk-2d0da7be"
	],
	"./hand.svg": [
		"5522"
	],
	"./health.svg": [
		"b0e9",
		"chunk-2d20edf8"
	],
	"./heart-minus.svg": [
		"c82b",
		"chunk-2d217a5b"
	],
	"./heart.svg": [
		"302e",
		"chunk-2d0b8a86"
	],
	"./help.svg": [
		"2220",
		"chunk-2d0b1d74"
	],
	"./hotel.svg": [
		"a977",
		"chunk-2d2095ce"
	],
	"./house.svg": [
		"9172",
		"chunk-2d0e48e9"
	],
	"./id.svg": [
		"04ff",
		"chunk-2d0a42ba"
	],
	"./identification.svg": [
		"8089",
		"chunk-2d0dd0ef"
	],
	"./illustrations/bankassurance-auto.svg": [
		"ee3e",
		"chunk-2d230c28"
	],
	"./illustrations/bankassurance-health.svg": [
		"4f78",
		"chunk-2d0cca09"
	],
	"./illustrations/bankassurance-travel.svg": [
		"f9a6",
		"chunk-2d22e0be"
	],
	"./illustrations/cards-flex.svg": [
		"002d",
		"chunk-2d0a2d68"
	],
	"./illustrations/cards-kamba.svg": [
		"dc57",
		"chunk-2d229057"
	],
	"./illustrations/cards-multicaixa.svg": [
		"a30e",
		"chunk-2d207e9d"
	],
	"./illustrations/cards-withdraw.svg": [
		"be47",
		"chunk-2d21aefc"
	],
	"./illustrations/cards.svg": [
		"f119",
		"chunk-2d22bce9"
	],
	"./illustrations/company-payments-merchant.svg": [
		"4e58"
	],
	"./illustrations/definitions-accounts-groups.svg": [
		"24b9",
		"chunk-2d0b2acf"
	],
	"./illustrations/definitions-active-channels.svg": [
		"c50c",
		"chunk-2d216edb"
	],
	"./illustrations/definitions-history.svg": [
		"9ad7",
		"chunk-2d0f0291"
	],
	"./illustrations/definitions-notifications.svg": [
		"3a76",
		"chunk-2d0c42e3"
	],
	"./illustrations/definitions-password.svg": [
		"b758",
		"chunk-2d21026e"
	],
	"./illustrations/definitions-username.svg": [
		"ef5c",
		"chunk-2d231025"
	],
	"./illustrations/emptyState/acessions.svg": [
		"1055",
		"chunk-2d0aa1f5"
	],
	"./illustrations/emptyState/approvals.svg": [
		"5e38",
		"chunk-2d0d3a2b"
	],
	"./illustrations/emptyState/available-soon.svg": [
		"c6d6",
		"chunk-2d2178bb"
	],
	"./illustrations/emptyState/bankassurance-policies.svg": [
		"985f",
		"chunk-2d0e6326"
	],
	"./illustrations/emptyState/batchfile-cards.svg": [
		"54a9",
		"chunk-2d0c87cd"
	],
	"./illustrations/emptyState/batchfile-consult-cards.svg": [
		"a73a",
		"chunk-2d208dfa"
	],
	"./illustrations/emptyState/batchfile-transfers.svg": [
		"fd62",
		"chunk-2d237cf0"
	],
	"./illustrations/emptyState/beneficiaries.svg": [
		"d8b2",
		"chunk-2d21f45a"
	],
	"./illustrations/emptyState/camara-no-access.svg": [
		"464e",
		"chunk-2d0c15a9"
	],
	"./illustrations/emptyState/cards-flex.svg": [
		"4a22",
		"chunk-2d0cb6a3"
	],
	"./illustrations/emptyState/cards-generic.svg": [
		"a876",
		"chunk-2d20920c"
	],
	"./illustrations/emptyState/cards-kamba.svg": [
		"198b",
		"chunk-2d0ac448"
	],
	"./illustrations/emptyState/cards-multicaixa.svg": [
		"7118",
		"chunk-2d0d5f77"
	],
	"./illustrations/emptyState/cards-withdraw.svg": [
		"ce79",
		"chunk-2d2223ba"
	],
	"./illustrations/emptyState/companyPayments-tpa-requests.svg": [
		"7472",
		"chunk-2d0d6b6e"
	],
	"./illustrations/emptyState/consult-mode.svg": [
		"abfe",
		"chunk-2d213596"
	],
	"./illustrations/emptyState/converter.svg": [
		"e476",
		"chunk-2d225484"
	],
	"./illustrations/emptyState/favorites-folder.svg": [
		"ba92",
		"chunk-2d21a08e"
	],
	"./illustrations/emptyState/filters.svg": [
		"72f5",
		"chunk-2d0d69a0"
	],
	"./illustrations/emptyState/history-naHora.svg": [
		"5ded",
		"chunk-2d0d3ca4"
	],
	"./illustrations/emptyState/location.svg": [
		"0509",
		"chunk-2d0a3fc4"
	],
	"./illustrations/emptyState/no-favorites-cards.svg": [
		"3eee",
		"chunk-2d0c57a8"
	],
	"./illustrations/emptyState/no-movements.svg": [
		"2c7d"
	],
	"./illustrations/emptyState/operators-light.svg": [
		"4a4d",
		"chunk-2d0cb713"
	],
	"./illustrations/emptyState/operators.svg": [
		"55fa",
		"chunk-2d0c8c51"
	],
	"./illustrations/emptyState/patrimony.svg": [
		"51ae",
		"chunk-2d0c7cb6"
	],
	"./illustrations/emptyState/payments.svg": [
		"df44",
		"chunk-2d229b78"
	],
	"./illustrations/emptyState/savings.svg": [
		"a9b8",
		"chunk-2d209b04"
	],
	"./illustrations/emptyState/search.svg": [
		"42bc",
		"chunk-2d0c0c35"
	],
	"./illustrations/emptyState/search2.svg": [
		"fbd2",
		"chunk-2d237b00"
	],
	"./illustrations/emptyState/statement.svg": [
		"2a78",
		"chunk-2d0bce86"
	],
	"./illustrations/emptyState/transfers-international.svg": [
		"5a92",
		"chunk-2d0d2bdb"
	],
	"./illustrations/emptyState/transfers-periodic.svg": [
		"4a8d",
		"chunk-2d0cb78f"
	],
	"./illustrations/join-bai-direct.svg": [
		"8dfe",
		"chunk-2d0e99e1"
	],
	"./illustrations/open-bank-account.svg": [
		"3dea",
		"chunk-2d0c53e3"
	],
	"./illustrations/operationFeedback/error-color-reversed.svg": [
		"4e0a",
		"chunk-2d0cc598"
	],
	"./illustrations/operationFeedback/error.svg": [
		"7b45",
		"chunk-2d0e17c2"
	],
	"./illustrations/operationFeedback/pending-color-reversed.svg": [
		"3699",
		"chunk-2d0ba1b9"
	],
	"./illustrations/operationFeedback/pending.svg": [
		"68a2",
		"chunk-2d0d0b29"
	],
	"./illustrations/operationFeedback/success-color-reversed.svg": [
		"22d2",
		"chunk-2d0b2384"
	],
	"./illustrations/operationFeedback/success.svg": [
		"5e2f",
		"chunk-2d0d3a3a"
	],
	"./illustrations/operators.svg": [
		"1f83"
	],
	"./illustrations/payments-bai-paga.svg": [
		"bb84",
		"chunk-2d21a432"
	],
	"./illustrations/payments-charge-ekwanza.svg": [
		"9e0c",
		"chunk-2d0f0b75"
	],
	"./illustrations/payments-education-books.svg": [
		"e686",
		"chunk-2d225c25"
	],
	"./illustrations/payments-education.svg": [
		"74fd",
		"chunk-2d0d7151"
	],
	"./illustrations/payments-habitation.svg": [
		"6c89",
		"chunk-2d0da7a4"
	],
	"./illustrations/payments-public-services.svg": [
		"542b",
		"chunk-2d0c8245"
	],
	"./illustrations/payments-reference.svg": [
		"223f",
		"chunk-2d0b1dc9"
	],
	"./illustrations/payments-services.svg": [
		"3510",
		"chunk-2d0b9cf7"
	],
	"./illustrations/payments-state.svg": [
		"d248",
		"chunk-2d21d848"
	],
	"./illustrations/payments-turism.svg": [
		"bcbb",
		"chunk-2d21ad37"
	],
	"./illustrations/payments-tv-net-telecom.svg": [
		"f7a4",
		"chunk-2d22d93a"
	],
	"./illustrations/secure-association.svg": [
		"f561",
		"chunk-2d22cc80"
	],
	"./illustrations/tpa.svg": [
		"632a"
	],
	"./illustrations/transfers-instant.svg": [
		"f163",
		"chunk-2d22bd7e"
	],
	"./illustrations/transfers-international.svg": [
		"9b2c",
		"chunk-2d0f0070"
	],
	"./illustrations/transfers-kwik-manageAccounts.svg": [
		"b0ce",
		"chunk-2d20ede6"
	],
	"./illustrations/transfers-kwik.svg": [
		"676c",
		"chunk-2d0d0264"
	],
	"./illustrations/transfers_nacional.svg": [
		"9d79",
		"chunk-2d0f0863"
	],
	"./illustrations/wallet-charge.svg": [
		"158e",
		"chunk-2d0ab547"
	],
	"./illustrations/wallet-regist.svg": [
		"b228",
		"chunk-2d20ef4c"
	],
	"./image-search.svg": [
		"4108"
	],
	"./image.svg": [
		"8591",
		"chunk-2d0de3cb"
	],
	"./info.svg": [
		"845c",
		"chunk-2d0ddfc0"
	],
	"./internet.svg": [
		"39ed",
		"chunk-2d0bb27b"
	],
	"./key.svg": [
		"4412",
		"chunk-2d0c0d97"
	],
	"./language.svg": [
		"5380",
		"chunk-2d0c7f0c"
	],
	"./leisure.svg": [
		"221c",
		"chunk-2d0b1d88"
	],
	"./letter.svg": [
		"5b0b",
		"chunk-2d0d2eb5"
	],
	"./link.svg": [
		"002e",
		"chunk-2d0a2d69"
	],
	"./list.svg": [
		"e68e"
	],
	"./location.svg": [
		"a20e",
		"chunk-2d207adc"
	],
	"./lock.svg": [
		"b7d0"
	],
	"./login.svg": [
		"28a4",
		"chunk-2d0b39af"
	],
	"./logout.svg": [
		"343a"
	],
	"./manage-accounts.svg": [
		"b717",
		"chunk-2d2101f1"
	],
	"./map-pin-agency.svg": [
		"f8ab",
		"chunk-2d22dd29"
	],
	"./map.svg": [
		"a6f3",
		"chunk-2d209038"
	],
	"./menu.svg": [
		"6ff4",
		"chunk-2d0db874"
	],
	"./minus.svg": [
		"e78d"
	],
	"./money-bag.svg": [
		"9618",
		"chunk-2d0e5afa"
	],
	"./money.svg": [
		"a20a",
		"chunk-2d207ad8"
	],
	"./moon.svg": [
		"467b",
		"chunk-2d0c1603"
	],
	"./more-settings.svg": [
		"e8e6",
		"chunk-2d22691a"
	],
	"./more.svg": [
		"0828"
	],
	"./movel.svg": [
		"0f88",
		"chunk-2d0af8ac"
	],
	"./no-category.svg": [
		"4da5",
		"chunk-2d0cc79a"
	],
	"./note.svg": [
		"790b",
		"chunk-2d0d7d8a"
	],
	"./open-new.svg": [
		"da7e",
		"chunk-2d228941"
	],
	"./overview.svg": [
		"53ab",
		"chunk-2d0c8435"
	],
	"./payment-single.svg": [
		"cff8",
		"chunk-2d222d2b"
	],
	"./pencil-line.svg": [
		"640b"
	],
	"./pencil.svg": [
		"b249"
	],
	"./people.svg": [
		"fa24",
		"chunk-2d237133"
	],
	"./percent.svg": [
		"53e0",
		"chunk-2d0c847f"
	],
	"./person-reuse.svg": [
		"5c33",
		"chunk-2d0d32a4"
	],
	"./person.svg": [
		"a001",
		"chunk-2d207326"
	],
	"./phone.svg": [
		"6e21",
		"chunk-2d0dae64"
	],
	"./pig.svg": [
		"aab7",
		"chunk-2d21312b"
	],
	"./pin-drop.svg": [
		"4a65"
	],
	"./plus.svg": [
		"9e7b"
	],
	"./public-service.svg": [
		"1d1e",
		"chunk-2d0b64dd"
	],
	"./qr-code.svg": [
		"8f97",
		"chunk-2d0e9bc2"
	],
	"./radio-error.svg": [
		"1a6f",
		"chunk-2d0b5a36"
	],
	"./radio-selected.svg": [
		"6296",
		"chunk-2d0cefcf"
	],
	"./radio.svg": [
		"e5f8",
		"chunk-2d225df8"
	],
	"./record-user.svg": [
		"7e7a",
		"chunk-2d0e238e"
	],
	"./rejected.svg": [
		"5f3b",
		"chunk-2d0d3e16"
	],
	"./rent.svg": [
		"7dac",
		"chunk-2d0e24e5"
	],
	"./restart.svg": [
		"177e",
		"chunk-2d0abcaa"
	],
	"./rocket.svg": [
		"84c2",
		"chunk-2d0de521"
	],
	"./safe.svg": [
		"6517",
		"chunk-2d0cfa1b"
	],
	"./saved-login.svg": [
		"3489",
		"chunk-2d0b9a18"
	],
	"./search.svg": [
		"e408"
	],
	"./settings.svg": [
		"4949",
		"chunk-2d0c20c0"
	],
	"./shield-insurance.svg": [
		"afa1",
		"chunk-2d2143cb"
	],
	"./shield.svg": [
		"a232",
		"chunk-2d207b06"
	],
	"./sport.svg": [
		"21f7",
		"chunk-2d0b2006"
	],
	"./star-minus.svg": [
		"4229",
		"chunk-2d0c063b"
	],
	"./star.svg": [
		"0995",
		"chunk-2d0a4fdb"
	],
	"./sun.svg": [
		"1cbf",
		"chunk-2d0b670c"
	],
	"./tag.svg": [
		"208a",
		"chunk-2d0b16dd"
	],
	"./ticket.svg": [
		"08c7",
		"chunk-2d0a5132"
	],
	"./transfer.svg": [
		"a5ae",
		"chunk-2d208c0e"
	],
	"./transports.svg": [
		"7857",
		"chunk-2d0d7a39"
	],
	"./trending-up.svg": [
		"cb6a",
		"chunk-2d221880"
	],
	"./trip.svg": [
		"e5ae",
		"chunk-2d225d8a"
	],
	"./unlock.svg": [
		"2957",
		"chunk-2d0b381f"
	],
	"./ussd.svg": [
		"69d2",
		"chunk-2d0d0f47"
	],
	"./wallet.svg": [
		"d754",
		"chunk-2d21eb28"
	],
	"./warning.svg": [
		"5daa"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "153d";
module.exports = webpackAsyncContext;